import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { TicketsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TTicket, TTicketsViewModel } from '@shared/models';
import { PhoneMaskDirective } from '@shared/directives';

@Component({
    'selector': 'app-ticket1Passenger',
    'templateUrl': './ticket1Passenger.page.html',
    'styleUrls': ['./ticket1Passenger.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, PhoneMaskDirective ]
})
export class Ticket1PassengerPage extends ViewBasePage implements OnInit, OnDestroy {
    public isDebugMode = false;
    public vm: TTicketsViewModel;
    public uid = '0';
    public submitted = false;

    constructor(private activatedRoute: ActivatedRoute, 
        private ticketsService: TicketsService, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_TICKETS_PAGE1);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        this.initializeTicket();
        this.isDebugMode = (this.sessionService.isDebugMode());

        const uid = this.activatedRoute.snapshot.paramMap.get('uid');
        if (uid) {
            this.vm.ticket = await this.ticketsService.getByUid(uid);
            // this.vm.ticket.dropoff = this.vm.ticket.dropoff || {};
            // this.vm.ticket.pickup = this.vm.ticket.pickup || {};
            this.vm.ticket.cellPhone = this.utilsService.formatPhoneNumberForDisplay(this.vm.ticket.cellPhone);

            // The fact that we have a ticket means the address was verified.
            this.vm.addressVerified = true;
            // this.vm.step2Complete = false;
        }
        // this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-ticket-1-tour');
    // }

    public onNextClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        this.setViewModel(this.vm);
        this.router.navigateByUrl('/tickets/ticket2Destination');
    }

    public onToggleUrgencyClick() {
        this.vm.isUrgencyStr = (this.vm.ticket.isUrgent) ? 'Urgent' : 'Non-Urgent';
    }

    private initializeTicket() {
        // const accountProfile = this.sessionService.getAccountProfile();
        const dealershipProfile = this.sessionService.getDealership();

        this.vm = {
            isUrgencyStr: 'Non-Urgent',
            directionStr: 'From Dealership',
            addressVerified: false,
            addressVerifiedMsg: '',
            step2Complete: false,
            pickupFullAddressFoundMsg: '',
            dropoffFullAddressFoundMsg: '',

            ticket: {
                status: 'pending',
                numPassengers: 1,
                passengerName: '',
                serviceAdvisor: this.sessionService.getUsersFullName,
                isUrgent: false,
                fromDealership: true,
                cellPhone: '',
                uid: '',

                dropoff: {
                    locationName: null,
                    address: {
                        city: '',
                        zipcode: '',
                        streetAddress: '',
                        coordinate: undefined,
                        countryAbbr: dealershipProfile.address.countryAbbr,
                        countryName: dealershipProfile.address.countryName,
                        fullAddress: '',
                        // formattedAddress: '',
                        isoCountryCode: '',
                        // isoRegionCode: '',
                        regionName: dealershipProfile.address.regionName,
                        regionCode: dealershipProfile.address.regionCode,
                    }
                },

                pickup: {
                    locationName: null,
                    address: {
                        city: '',
                        zipcode: '',
                        streetAddress: '',
                        coordinate: undefined,
                        countryAbbr: dealershipProfile.address.countryAbbr,
                        countryName: dealershipProfile.address.countryName,
                        // formattedAddress: '',
                        fullAddress: '',
                        isoCountryCode: '',
                        // isoRegionCode: '',
                        regionName: dealershipProfile.address.regionName,
                        regionCode: dealershipProfile.address.regionCode,
                    }
                },
            }
        }


        // this.vm.ticket.pickup = {};
        // this.vm.ticket.pickup.city = null;
        // this.vm.ticket.pickup.zipcode = null;
        // this.vm.ticket.pickup.locationName = null;
        // this.vm.ticket.pickup.streetAddress = null;
        // this.vm.ticket.pickup.state = dealershipProfile.address.regionName;
        // this.vm.ticket.pickup.statecode = dealershipProfile.address.regionCode;
        // this.vm.ticket.pickup.countryName = dealershipProfile.address.countryName;
        // this.vm.ticket.pickup.countryAbbr = dealershipProfile.address.countryAbbr;
    }
}
